<template>
  <footer class="app-footer" :style="footerStyle">
    <span class="footer-rail"></span>
    <div class="footer-inner">
      <div class="footer-col footer-col--start">
        <span class="footer-mark">
          <img src="/sarpaico.ico" alt="" class="footer-logo" aria-hidden="true" />
        </span>
        <span class="footer-copy">
          <span class="footer-name">Sarpa Odisha</span>
          <span class="footer-fine">
            &copy; {{ new Date().getFullYear() }} All rights reserved
          </span>
        </span>
      </div>

      <div class="footer-col footer-col--center">
        <span class="footer-fine">
          Designed &amp; maintained by
          <a
            href="https://leopardtechlabs.com"
            target="_blank"
            rel="noopener"
            class="footer-link"
            >Leopard Tech Labs</a
          >
        </span>
        <router-link to="/privacyPolicy" class="footer-link footer-link--quiet">
          Privacy Policy
        </router-link>
      </div>

      <div class="footer-col footer-col--end">
        <span class="footer-dept">Odisha Forest Department</span>
        <span class="footer-fine">Government of Odisha</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    footerStyle() {
      // Check if we are on a page that requires authentication (which uses the admin layout with the sidebar)
      const isLoggedPage = this.$route.matched.some(
        (record) => record.meta.requiresAuth
      );
      // Check if the screen is desktop size (sidebar is visible only on 'md' screens and above)
      const isDesktop = !["xs", "sm"].includes(this.$vuetify.breakpoint.name);

      if (isLoggedPage && isDesktop) {
        return {
          marginLeft: "280px",
          width: "calc(100% - 280px)",
        };
      }
      return {};
    },
  },
};
</script>

<style scoped>
/*
 * Was a flat black bar with grey text, which matched nothing else in the
 * portal. Now the same deep emerald the login hero uses, with the brand rail
 * the cards carry, so it reads as the bottom of this product rather than a
 * default.
 */
.app-footer {
  position: relative;
  flex: 0 0 auto;
  padding: 22px 28px;
  background: linear-gradient(135deg, #0d2a1a 0%, #071d12 60%, #04120a 100%);
}
.footer-rail {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 3px;
  background: linear-gradient(90deg, #10b981 0%, #047857 55%, #065f46 100%);
}
.footer-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 18px 26px;
  max-width: 1560px;
  margin: 0 auto;
}
.footer-col {
  display: flex;
  min-width: 0;
}
.footer-col--start {
  align-items: center;
  gap: 12px;
}
.footer-col--center {
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  text-align: center;
}
.footer-col--end {
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  text-align: right;
}

.footer-mark {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* a step below the brand emerald so the mark keeps its edge on the tile */
  background: linear-gradient(135deg, #0ea97a 0%, #047857 100%);
  box-shadow: 0 6px 16px -6px rgba(5, 150, 105, 0.6);
  overflow: hidden;
}
.footer-logo {
  width: 26px;
  height: 26px;
  object-fit: contain;
}
.footer-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.footer-name {
  font-family: poppinssemibold, poppinsregular, sans-serif;
  font-size: 13.5px;
  letter-spacing: 0.2px;
  color: #ffffff;
}
.footer-dept {
  font-family: poppinsmedium, poppinsregular, sans-serif;
  font-size: 13px;
  letter-spacing: 0.2px;
  color: #ffffff;
}
/* 4.9:1 on the footer's darkest step - the old #d1d1d1 on black was louder
   than the headings it sat under */
.footer-fine {
  font-family: poppinsregular, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.62);
}
.footer-link {
  color: #34d399 !important;
  font-family: poppinsmedium, poppinsregular, sans-serif;
  text-decoration: none;
}
.footer-link:hover {
  text-decoration: underline;
}
.footer-link--quiet {
  font-size: 12px;
}

@media (max-width: 860px) {
  .app-footer {
    padding: 20px 18px;
  }
  .footer-inner {
    flex-direction: column;
    align-items: center;
    gap: 14px;
  }
  .footer-col--end,
  .footer-col--center {
    align-items: center;
    text-align: center;
  }
}
</style>
